import { type Token } from '@app/client';

export const ACTION_SET_TOKENS = 'ACTION_SET_TOKENS';
export const ACTION_REMOVE_TOKENS = 'ACTION_REMOVE_TOKENS';
export const ACTION_SET_MAGIC_LINK_EMAIL = 'ACTION_SET_MAGIC_LINK_EMAIL';
export const ACTION_SET_LAST4 = 'ACTION_SET_LAST4';
export const ACTION_SET_LOADING_USER = 'ACTION_SET_LOADING_USER';

interface SetTokensAction {
    type: typeof ACTION_SET_TOKENS;
    isDraftUser?: boolean;
    tokens: Token;
}

interface RemoveTokensAction {
    type: typeof ACTION_REMOVE_TOKENS;
}

interface SetMagicLinkEmailAction {
    type: typeof ACTION_SET_MAGIC_LINK_EMAIL;
    magicLinkEmail: string;
}

interface SetLast4Action {
    type: typeof ACTION_SET_LAST4;
    last4: string;
}

export interface AuthState {
    hasPassword: boolean;
    isDraftUser?: boolean;
    magicLinkEmail: string | null;
    last4: string;
    loadingUser: boolean;
}
interface SetLoadingUserAction {
    type: typeof ACTION_SET_LOADING_USER;
    loadingUser: boolean;
}
export type AuthActionTypes =
    | SetTokensAction
    | RemoveTokensAction
    | SetMagicLinkEmailAction
    | SetLast4Action
    | SetLoadingUserAction;
